export default __webpack_public_path__ + "static/media/mindfulness.f665a85b.svg";